import React, { useEffect, useState } from 'react';
import { useLanguage } from './LanguageContext';
import { MenuIcon, XIcon, GlobeIcon } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
import { artwork } from './artwork';
import { Link, useLocation } from 'react-router-dom';
export function Navbar() {
  const {
    language,
    setLanguage,
    t
  } = useLanguage();
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const location = useLocation();
  const isHomePage = location.pathname === '/';
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  const navLinks = [{
    name: t.nav.home,
    href: isHomePage ? '#home' : '/#home'
  }, {
    name: t.nav.about,
    href: isHomePage ? '#about' : '/#about'
  }, {
    name: t.nav.services,
    href: isHomePage ? '#services' : '/#services'
  }, {
    name: t.nav.pricing,
    href: isHomePage ? '#pricing' : '/#pricing'
  }, {
    name: t.nav.clinic,
    href: isHomePage ? '#clinic' : '/#clinic'
  }, {
    name: t.nav.contact,
    href: isHomePage ? '#contact' : '/#contact'
  }];
  return <header className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${isScrolled ? 'bg-white/90 backdrop-blur-md shadow-sm py-3' : 'bg-transparent py-5'}`} data-id="element-164">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-165">
        <div className="flex justify-between items-center" data-id="element-166">
          {/* Logo */}
          <Link to="/" className="flex items-center space-x-3 group" data-id="element-167">
            <img src={artwork.LOGO_IMAGE} alt="Aissa Edon Logo" className="w-9 h-9 md:w-10 md:h-10 rounded-full object-cover border border-teal-100 shadow-sm group-hover:shadow-md transition-shadow" data-id="element-168" />
            <div className="flex flex-col" data-id="element-169">
              <span className="text-xl md:text-2xl font-serif font-semibold text-teal-800 leading-tight" data-id="element-170">
                Aissa Edon
              </span>
              <span className="text-[10px] md:text-xs font-medium text-slate-500 leading-tight" data-id="element-171"></span>
            </div>
          </Link>

          {/* Desktop Nav */}
          <nav className="hidden md:flex items-center space-x-4 lg:space-x-5" data-id="element-172">
            {navLinks.map(link => <a key={link.name} href={link.href} className="text-[13px] font-medium text-slate-600 hover:text-teal-600 transition-colors whitespace-nowrap" data-id="element-173">
                {link.name}
              </a>)}
          </nav>

          {/* Actions */}
          <div className="hidden md:flex items-center space-x-6" data-id="element-174">
            {/* Language Switcher */}
            <div className="flex items-center bg-slate-100 rounded-full p-1" data-id="element-175">
              <button onClick={() => setLanguage('en')} className={`px-3 py-1 text-xs font-medium rounded-full transition-colors ${language === 'en' ? 'bg-white text-teal-700 shadow-sm' : 'text-slate-500 hover:text-slate-700'}`} data-id="element-176">
                EN
              </button>
              <button onClick={() => setLanguage('fr')} className={`px-3 py-1 text-xs font-medium rounded-full transition-colors ${language === 'fr' ? 'bg-white text-teal-700 shadow-sm' : 'text-slate-500 hover:text-slate-700'}`} data-id="element-177">
                FR
              </button>
            </div>

            <Link to="/book-online" className="bg-teal-600 hover:bg-teal-700 text-white px-5 py-2 rounded-full text-sm font-medium transition-colors shadow-sm hover:shadow-md" data-id="element-178">
              {t.nav.bookNow}
            </Link>
          </div>

          {/* Mobile Menu Toggle */}
          <button className="md:hidden p-2 text-slate-600" onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)} data-id="element-179">
            {isMobileMenuOpen ? <XIcon size={24} data-id="element-180" /> : <MenuIcon size={24} data-id="element-181" />}
          </button>
        </div>
      </div>

      {/* Mobile Menu */}
      <AnimatePresence data-id="element-182">
        {isMobileMenuOpen && <motion.div initial={{
        opacity: 0,
        height: 0
      }} animate={{
        opacity: 1,
        height: 'auto'
      }} exit={{
        opacity: 0,
        height: 0
      }} className="md:hidden bg-white border-t border-slate-100 shadow-lg overflow-hidden" data-id="element-183">
            <div className="px-4 py-6 space-y-4 flex flex-col" data-id="element-184">
              {navLinks.map(link => <a key={link.name} href={link.href} onClick={() => setIsMobileMenuOpen(false)} className="text-base font-medium text-slate-700 hover:text-teal-600 block py-2" data-id="element-185">
                  {link.name}
                </a>)}

              <div className="pt-4 border-t border-slate-100 flex items-center justify-between" data-id="element-186">
                <div className="flex items-center space-x-2 text-slate-600" data-id="element-187">
                  <GlobeIcon size={18} data-id="element-188" />
                  <span className="text-sm font-medium" data-id="element-189">Language</span>
                </div>
                <div className="flex items-center bg-slate-100 rounded-full p-1" data-id="element-190">
                  <button onClick={() => {
                setLanguage('en');
                setIsMobileMenuOpen(false);
              }} className={`px-4 py-1.5 text-sm font-medium rounded-full transition-colors ${language === 'en' ? 'bg-white text-teal-700 shadow-sm' : 'text-slate-500'}`} data-id="element-191">
                    EN
                  </button>
                  <button onClick={() => {
                setLanguage('fr');
                setIsMobileMenuOpen(false);
              }} className={`px-4 py-1.5 text-sm font-medium rounded-full transition-colors ${language === 'fr' ? 'bg-white text-teal-700 shadow-sm' : 'text-slate-500'}`} data-id="element-192">
                    FR
                  </button>
                </div>
              </div>

              <Link to="/book-online" onClick={() => setIsMobileMenuOpen(false)} className="mt-4 w-full text-center bg-teal-600 text-white px-5 py-3 rounded-xl text-base font-medium" data-id="element-193">
                {t.nav.bookNow}
              </Link>
            </div>
          </motion.div>}
      </AnimatePresence>
    </header>;
}